import React from 'react';
import styled from 'styled-components';
import { Tabs, Tab } from '@material-ui/core';

export const StyledTabs = styled((props) => {
  return <Tabs {...props} classes={{ indicator: 'indicator' }}></Tabs>;
})`
  && {
    background-color: #f7f7f7;
    border-radius: 8px 8px 0 0;
    .MuiTab-wrapper {
      justify-content: flex-start;
      flex-direction: row;
    }
    button {
      padding: 15px 23px;
    }
  }
  && .indicator {
    height: 4px;
    background-color: #0880bc;
  }
`;

export const StyledTab = styled(Tab)`
  && {
    color: #9797af;
    font-size: 15px !important;
    font-weight: bold;
    line-height: 18px;
    text-transform: none;
    border-right: 1px solid #fff;
    border-left: 1px solid #fff;
    &:focus {
      color: #0880bc !important;
      background-color: #fff !important;
    }
    &&.Mui-selected {
      color: #0880bc;
      background-color: #fff;
    }
  }
`;
